/**
 * Recommendations — categories service
 *
 * Fetches categories recommended to the current user based on their location.
 *
 * Endpoint: GET /api/recommendations/categories
 *
 * Errors:
 *   401 — unauthenticated
 *   422 "user_has_no_location" — user has no location set
 */
import { createApiWithNewBasePath as api } from "@api";
import { IRecommendedCategoriesResponse } from "../types/recommendations.types";

export const API_PATH = "recommendations/categories";

export const getRecommendedCategories = () =>
  api.get<undefined, IRecommendedCategoriesResponse>(API_PATH);
